import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';

const Loading = props => {
  const { text } = props;

  return <Spin size="large" tip={text || null} />;
};

Loading.propTypes = {
  text: PropTypes.string
};

Loading.defaultProps = {
  text: ''
};

export default Loading;
